import { render, staticRenderFns } from "./UpdateAddress.vue?vue&type=template&id=697cf6e5&scoped=true&"
import script from "./UpdateAddress.vue?vue&type=script&lang=js&"
export * from "./UpdateAddress.vue?vue&type=script&lang=js&"
import style0 from "./UpdateAddress.vue?vue&type=style&index=0&id=697cf6e5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697cf6e5",
  null
  
)

export default component.exports